import React from "react";
import { motion } from "framer-motion";

const STATS = [
  { kpi: "19", suffix: "+", label: "Años en el mercado" },
  { kpi: "2,400", suffix: "", label: "Familias asesoradas" },
  { kpi: "10", suffix: "", label: "Aseguradoras aliadas" },
  { kpi: "$4.8", suffix: "B", label: "Bajo asesoría" },
];

const INSURERS = [
  "Plan Seguro",
  "BX+",
  "Quálitas",
  "Insignia Life",
  "HDI",
  "GNP",
  "AXA",
  "La Latino",
  "Sura",
  "Ana Seguros",
];

const TrustBar = () => {
  return (
    <section className="py-24 lg:py-28 bg-white border-t border-razmek">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-razmek-blue/10 mb-20">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white p-8 lg:p-12"
            >
              <div className="flex items-baseline gap-1">
                <span className="font-serif text-5xl lg:text-6xl text-razmek-blue">
                  {s.kpi}
                </span>
                <span className="font-serif text-3xl text-razmek-gold">
                  {s.suffix}
                </span>
              </div>
              <div className="mt-3 eyebrow text-razmek-gray">{s.label}</div>
            </motion.div>
          ))}
        </div>

        {/* Insurers marquee */}
        <div className="text-center">
          <div className="eyebrow text-razmek-gray">
            Colaboramos con las principales aseguradoras
          </div>
        </div>
        <div
          className="mt-10 overflow-hidden border-y border-razmek py-10 marquee-wrapper"
          data-testid="insurers-marquee"
          style={{
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0, #000 10%, #000 90%, transparent 100%)",
            maskImage:
              "linear-gradient(to right, transparent 0, #000 10%, #000 90%, transparent 100%)",
          }}
        >
          <div
            className="flex marquee-track gap-24 whitespace-nowrap"
            style={{ width: "max-content" }}
          >
            {[...INSURERS, ...INSURERS].map((name, i) => {
              const copy = i < INSURERS.length ? "a" : "b";
              return (
                <span
                  key={`${name}-${copy}`}
                  data-testid={`insurer-${i}`}
                  className="insurer-item font-serif text-2xl lg:text-3xl text-razmek-dark/45 tracking-wide shrink-0 cursor-default transition-colors duration-300 hover:text-razmek-blue"
                  style={{ letterSpacing: "0.08em" }}
                >
                  {name}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
